module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalInforme) ? _c('delegaciones-informe', {
    attrs: {
      "id": _vm.informe.id
    },
    on: {
      "close": _vm.closeModalInforme
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.mostrarModalEditar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('gestion-delegaciones-rrhh-guardar', {
    attrs: {
      "info": _vm.info
    },
    on: {
      "close": _vm.closeModalEditar,
      "closeRefresh": function($event) {
        return _vm.closeModalEditar(true)
      }
    }
  })], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalConfirmacionInactivar) ? _c('div', {
    key: "modal-inactivar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Inactivar delegación")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.modalConfirmacionInactivar = false
      }
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("¿Estás seguro de inactivar la delegación?")])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.inactivar
    }
  }, [(_vm.isLoading) ? _c('span', [_vm._v("Inactivando...")]) : _c('span', [_vm._v("Inactivar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        _vm.modalConfirmacionInactivar = false
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])]) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestion de delegaciones RRHH")])]), _c('div', {
    staticClass: "text-right"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("Ver inactivas")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verInactivas),
      expression: "verInactivas"
    }],
    staticClass: "mr-8",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.verInactivas) ? _vm._i(_vm.verInactivas, null) > -1 : (_vm.verInactivas)
    },
    on: {
      "input": _vm.handlerVerInactivas,
      "change": function($event) {
        var $$a = _vm.verInactivas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.verInactivas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.verInactivas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.verInactivas = $$c
        }
      }
    }
  }), _c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.openModalEditar('')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _c('span', [_vm._v("Refrescar")])])]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "table-delegaciones-rrhh",
    staticClass: "tabla"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Reemplazante")]), _c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Creación")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleadoOrigen
      }
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.nombreEmpleadoOrigen))]), _c('strong', {
      staticClass: "show-break-1"
    }, [_vm._v("Reemplazo:")]), _c('span', {
      staticClass: "show-break-1 hint--bottom",
      attrs: {
        "aria-label": 'Reemplazante: ' + o.dniEmpleadoReemplazante
      }
    }, [_vm._v(_vm._s(o.nombreEmpleadoReemplazante))])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Reemplazante: ' + o.dniEmpleadoReemplazante
      }
    }, [_c('span', [_vm._v(_vm._s(o.nombreEmpleadoReemplazante))])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [(o.fechaInicioString == o.fechaFinString) ? _c('span', [_vm._v(_vm._s(o.fechaInicioString))]) : _c('div', {
      staticClass: "fechas"
    }, [_c('span', [_vm._v(_vm._s(o.fechaInicioString))]), _c('span', {
      staticClass: "hide-break-guion"
    }, [_vm._v("-")]), _c('span', [_vm._v(_vm._s(o.fechaFinString))])]), _c('strong', {
      staticClass: "show-break-1"
    }, [_vm._v("Creado:")]), _c('span', {
      staticClass: "show-break-1"
    }, [_vm._v(_vm._s(o.creado))])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.creado))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [(o.activo) ? _c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.openModalEditar(o.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]) : _vm._e(), _c('button', {
      staticClass: "button is-small is-danger mt-10",
      on: {
        "click": function($event) {
          return _vm.abrirModalInactivar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Inactivar")])]), _c('button', {
      staticClass: "button is-small mt-10",
      on: {
        "click": function($event) {
          return _vm.abrirModalInforme(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Informe")])])])])])])
  }), 0)], 1) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    key: "message",
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42a3ea4b","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Gestion_Delegaciones_RRHH.vue
// module id = 799
// module chunks = 0